// // import React from 'react';
// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
// import Layout from "../pages/Layout";
// import HomeIcon from "../assets/icons/home_icon";
// import Logo from "../images/bentex-logo.png";
// import axios from "axios";
// import config from "../config";
// import { jsPDF } from "jspdf";
// import { useRef } from 'react';
// import html2pdf from "html2pdf.js";
// import { toast } from "react-toastify";
// import ClipLoader from "react-spinners/ClipLoader";

// const Invoice = ({ customerDetails, invoiceDetails, items, handlePDF }) => {
//   const { id } = useParams();
//   const location = useLocation();
//   const [amountPaid, setAmountPaid] = useState(0);
//   const navigate = useNavigate()
//   const [deposits, setDeposits] = useState([
//     { percent: 0, amount: 0, mode: "" },
//     { percent: 0, amount: 0, mode: "" },
//     { percent: 0, amount: 0, mode: "" },
//   ]);


//   const queryParams = new URLSearchParams(location.search);
//   // const totalPrice = queryParams.get("total_price");

//   const [uploadedImages, setUploadedImages] = useState([]);
//   const [isEmailLoading, setIsEmailLoading] = useState(false);


//   const [quoteNo, setQuoteNo] = useState("");

//  const [base64Images, setBase64Images] = useState([]);
//  const [discount , setDiscount] = useState(0)
//   const [isLoading, setIsLoading] = useState(true);

//   const [comments, setComments] = useState("");
//   const [customer, setCustomer] = useState("");
//   const [products, setProducts] = useState([]);
//   const [amountDue, setAmountDue] = useState();
//   const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split('T')[0]);
//   const [invoiceNo, setInvoiceNo] = useState("");
//   const [totalPrice, setTotalPrice] = useState(0);
//   const [quoteId,setQuoteId] = useState(null)
//   const [modeOfPayment, setModeOfPayment] = useState("");

//   // const [amountDue, setAmountDue] = useState("");
//   const [totalAmount, setTotalAmount] = useState("");
//   // const [invoiceNo, setInvoiceNo] = useState("");

//   // console.log(customer)

//   // console.log(invoiceNo)

//   useEffect(() => {
//     setAmountDue(totalAmount - amountPaid);
//   }, [totalAmount, amountPaid]); // ✅ dependency array


//   useEffect(() => {
//   const convertImagesToBase64 = async () => {
//     const promises = uploadedImages.map(async (img) => {
//       if (img instanceof File) {
//         return await toBase64(img);
//       } else {
//         // for already saved image paths from backend
//         return `${config.BASE_URL}${img}`;
//       }
//     });

//     const results = await Promise.all(promises);
//     setBase64Images(results);
//   };

//   convertImagesToBase64();
// }, [uploadedImages]);

// const toBase64 = (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
//   });


//  useEffect(() => {
//   const tp = parseFloat(totalAmount) || 0;
//   if (tp === 0) return;

//   const updated = deposits.map((d) => {
//     const amount = parseFloat(d.amount) || 0;
//     const percent = (amount / tp) * 100;

//     return {
//       ...d,
//       amount: amount,               // keep original amount
//       percent: percent, // recalc percent
//     };
//   });

//   setDeposits(updated);

//   const totalPaid = updated.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
//   setAmountPaid(totalPaid);
//   setAmountDue(tp - totalPaid);
// }, [totalAmount]);

//   useEffect(() => {
//   const convertImages = async () => {
//     const results = await Promise.all(
//       uploadedImages.map(async (img) => {
//         if (img instanceof File) {
//           return await toBase64(img);
//         } else {
//           return `${config.BASE_URL}${img}`;
//         }
//       })
//     );
//     setBase64Images(results);
//   };

//   convertImages();
// }, [uploadedImages]);

//   // console.log(amountDue)

//   const fetchInvoice = async (invoiceId) => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${config.BASE_URL}/api/v1/invoice/${invoiceId}`);
//       setInvoiceNo(response?.data.invoice.invoice_no)
//       // setDeposit(response?.data.invoice.deposit)
//       setTotalAmount(response?.data.invoice.amount)
//       setModeOfPayment(response?.data.invoice.modeOfPayment)
//       setAmountPaid(response?.data.invoice.amount_paid)
//       setComments(response?.data.invoice.comments)
//       setCustomer(response.data?.invoice?.customer_id);
//       setUploadedImages(response.data?.invoice?.images || []);

//       const depositData = response?.data.invoice.deposit;

//        setQuoteId(response?.data?.invoice?.quote_id?._id)
//        setDiscount(Number(response.data?.invoice?.quote_id?.discount))
//        const fetchQuoteDetails = async () => {
//         setIsLoading(true);
//       try {
//         const response1 = await axios.get(`${config.BASE_URL}/api/v1/getProductDetails-by-quoteId/${response?.data?.invoice?.quote_id?._id}`);
//         const data = response1.data.products;
//         // console.log(data)
//         const productData = response.data.productDetail

//         setProducts(data || []);


//       } catch (error) {
//         console.error("Error fetching quote details:", error);
//       }
//       finally{
//       setIsLoading(false);
//     }
//         };

//         if (response.data) {
//           fetchQuoteDetails();
//         }



// // if (Array.isArray(depositData)) {
// //   setDeposits(depositData);       
// // }

// if (Array.isArray(depositData)) {
//   const normalizedDeposits = [
//     { percent: 0, amount: 0, mode: "" },
//     { percent: 0, amount: 0, mode: "" },
//     { percent: 0, amount: 0, mode: "" },
//   ];

//   depositData.forEach((d, i) => {
//     if (i < 3) {
//       normalizedDeposits[i] = {
//         percent: Number(d.percent) || 0,
//         amount: Number(d.amount) || 0,
//         mode: d.mode || "",
//       };
//     }
//   });

//   setDeposits(normalizedDeposits);
// }

//     } catch (error) {
//       console.error("Failed to fetch invoice:", error);
//     }
//     finally{
//       setIsLoading(false);
//     }
//   };




// //  const handleDepositChange = (index, field, value) => {
// //   const updated = [...deposits];
// //   let numericValue = parseFloat(value) || 0;

// //   if (field === "percent") {
// //     const amount = (numericValue / 100) * totalAmount;
// //     updated[index] = { ...updated[index], percent: numericValue, amount };
// //   } else if (field === "amount") {
// //     const percent = (numericValue / totalAmount) * 100;
// //     updated[index] = { ...updated[index], amount: numericValue, percent };
// //   } else if (field === "mode") {
// //     updated[index] = { ...updated[index], mode: value };
// //   }

// //   setDeposits(updated);
// //   const totalPaid = updated.reduce((acc, d) => acc + (parseFloat(d.amount) || 0), 0);
// //   console.log(totalPaid,"totalPaid4")
// //   setAmountPaid(totalPaid);
// //   setAmountDue((totalAmount || 0) - totalPaid);
// // };




//   // console.log(products)

//   // const generateRandomOrderNo = () => {
//   //   const randomNumber = Math.floor(Math.random() * 100000) + 1000;
//   //   return `AR${randomNumber}`;
//   // };

//   // const checkOrderNoExistence = async (generatedOrderNo) => {
//   //   try {
//   //     const response = await axios.get(`${config.BASE_URL}/api/v1/checkOrderNo`, {
//   //       params: { orderNo: generatedOrderNo }
//   //     });
//   //     return response.data.exists;
//   //   } catch (error) {
//   //     console.error("Error checking quote number existence:", error);
//   //     return false;
//   //   }
//   // };

//   // const generateUniqueOrderNo = async () => {
//   //   let isUnique = false;
//   //   let newOrderNo = "";

//   //   while (!isUnique) {
//   //     newOrderNo = generateRandomOrderNo();
//   //     isUnique = !(await checkOrderNoExistence(newOrderNo));
//   //   }

//   //   setInvoiceNo(newOrderNo);
//   // };

// const handleDepositChange = (index, field, value) => {
//     const totalInvoiceAmount = parseFloat(totalAmount) || 0;
//     const updated = [...deposits];
//     let numericValue = parseFloat(value) || 0;


//     // --- 1. Handle Amount Change (CRITICAL VALIDATION) ---
//    if (field === "amount") {
//         // Allow user to clear the field (empty string)
//         if (value === "") {
//             updated[index].amount = "";
//             updated[index].percent = 0;
//         } else {
//             let numericValue = parseFloat(value) || 0;

//             // Validation: Sum of all other deposits
//             const otherDepositsTotal = updated.reduce((acc, d, i) => {
//                 if (i !== index) return acc + (parseFloat(d.amount) || 0);
//                 return acc;
//             }, 0);

//             const maxAllowed = Math.max(0, totalInvoiceAmount - otherDepositsTotal);

//             if (numericValue > maxAllowed) {
//                 numericValue = maxAllowed;
//                 toast.warn(`Cannot exceed total remaining amount due ($${maxAllowed.toFixed(2)}).`);
//             }

//             updated[index].amount = numericValue;
//             const percent = totalInvoiceAmount > 0 ? (numericValue / totalInvoiceAmount) * 100 : 0;
//             updated[index].percent = percent.toFixed(2);
//         }
//     } else if (field === "percent") {
//         if (numericValue < 0) numericValue = 0;
//         if (numericValue > 100) numericValue = 100;

//         let calculatedAmount = (numericValue / 100) * totalInvoiceAmount;
//         calculatedAmount = parseFloat(calculatedAmount.toFixed(2));

//         if (calculatedAmount > totalInvoiceAmount) {
//             numericValue = 100;
//             updated[index].amount = totalInvoiceAmount;
//         } else {
//             updated[index].amount = calculatedAmount;
//         }
//         updated[index].percent = numericValue;


//     // --- 3. Handle Mode Change (Simple update) ---
//     } else if (field === "mode") {
//         updated[index].mode = value;
//     }

//     // --- 4. Final State Update ---
//     setDeposits(updated);

//     // Recalculate total paid from the final 'updated' array
//     const totalPaid = updated.reduce((acc, d) => acc + (parseFloat(d.amount) || 0), 0);
//     setAmountPaid(totalPaid);
//     setAmountDue(totalInvoiceAmount - totalPaid);
// };

//   useEffect(() => {
//     fetchInvoice(id);
//     // generateUniqueOrderNo();
//   }, []);




//   // const calculateAmountDue = (selectedDeposits) => {
//   //   let amountPaid = 0;

//   //   if (selectedDeposits.includes("25% deposit paid")) {
//   //     amountPaid += totalAmount * 0.25;
//   //     // console.log(amountPaid)
//   //     setAmountPaid(amountPaid);
//   //   }

//   //   if (selectedDeposits.includes("25% deposit due")) {
//   //     amountPaid += totalAmount * 0.25;
//   //     setAmountPaid(amountPaid);
//   //   }

//   //   if (selectedDeposits.includes("50% deposit paid")) {
//   //     amountPaid += totalAmount * 0.5;
//   //     setAmountPaid(amountPaid);
//   //   }


//   //   const due = totalAmount - amountPaid;
//   //   setAmountDue(due);
//   // };

//   // const handleGeneratePDF = () => {
//   //   const element = document.getElementById("invoice");
//   //   const options = {
//   //     margin: 0,
//   //     filename: 'invoice.pdf',
//   //     image: { type: 'jpeg', quality: 0.98 },
//   //     html2canvas: { scale: 2 },
//   //     jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//   //   };
//   //   html2pdf(element, options);
//   // };



// const handleGeneratePDF = async () => {
//   // Wait for base64Images to be populated if there are uploaded images
//   if (uploadedImages.length > 0 && base64Images.length !== uploadedImages.length) {
//     toast.error("Images are still loading, please try again in a moment.");
//     return;
//   }

//   const element = document.getElementById("invoice");

//   await waitForImagesToLoad(element);

//       const customerName = customer?.customer_name
//     ? customer.customer_name.replace(/\s+/g, "_")
//     : "Customer";

//   const today = new Date();
//  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
//   today.getMonth() + 1
// ).padStart(2, "0")}-${today.getFullYear()}`;

//   const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;

//   const options = {
//     margin: 0.2,
//     filename: fileName,
//     image: { type: 'jpeg', quality: 0.98 },
//     html2canvas: { 
//       scale: 2,
//       useCORS: true, // Enable cross-origin images
//       async: true, // Process asynchronously
//       logging: true,
//       ignoreElements: (el) => el.classList.contains("no-pdf"),
//     },
//     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
//     pagebreak: { 
//         mode: ['css', 'legacy'],
//         avoid: '.invoice_bottom_text'  
//       }
//   };

//   try {
//     // Generate PDF
//     await html2pdf().set(options).from(element).save();
//   } catch (error) {
//     console.error("Error generating PDF:", error);
//     toast.error("Failed to generate PDF. Please try again.");
//   }
// };

// // Helper function to wait for images to load
// const waitForImagesToLoad = (element) => {
//   const images = element.querySelectorAll('img');
//   return Promise.all(
//     Array.from(images).map(img => {
//       if (img.complete) {
//         return Promise.resolve();
//       }
//       return new Promise((resolve) => {
//         img.onload = img.onerror = resolve;
//       });
//     })
//   );
// };


//   const handleDeleteItem = (index) => {
//     const updatedProducts = products.filter((_, i) => i !== index);
//     setProducts(updatedProducts);
//   };


//   const handleAddItem = () => {
//     const newItem = {
//       style: '',
//       fabric: '',
//       lining: '',
//       quantity: '',
//       price: '',
//       image: null,
//     };
//     setProducts([...products, newItem]);
//   };


//  const handleEmail = async () => {
//     setIsEmailLoading(true);
//     const customerName = customer?.customer_name
//       ? customer.customer_name.replace(/\s+/g, "_")
//       : "Customer";

//     const today = new Date();
//     const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
//       today.getMonth() + 1
//     ).padStart(2, "0")}-${today.getFullYear()}`;

//     const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;
//     try {
//       const element = document.getElementById("invoice");
//       const options = {
//         margin: 0.2,
//         filename: fileName,
//         image: { type: "jpeg", quality: 0.98 },
//         html2canvas: {
//           scale: 2,
//           ignoreElements: (el) => el.classList.contains("no-pdf"),

//         },
//         jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
//         pagebreak: { 
//         mode: ['css', 'legacy'], // Enable CSS parsing
//         avoid: '.invoice_bottom_text'  // EXACTLY matches your class name
//       }
//       };



//       const pdfBlob = await html2pdf().from(element).set(options).outputPdf("blob");



//       const formData = new FormData();
//       formData.append("name", customer.customer_name);
//       formData.append("email", customer.email);
//       formData.append("subject", invoiceNo);
//       formData.append("title", fileName);
//       formData.append("pdf", pdfBlob, "invoice.pdf");
//       formData.append("type", "invoice")

//     const existingImagePaths = uploadedImages.filter(
//     (image) => typeof image === 'string'
//   );
//   const newImageFiles = uploadedImages.filter(
//     (image) => image instanceof File
//   );

//   // 2. Append ONLY the new files to the 'invoiceImages' field for multer
//   newImageFiles.forEach((file) => {
//     formData.append("invoiceImages", file);
//   });

//   // 3. Send the list of old image paths as a separate JSON string
//   formData.append("existingImages", JSON.stringify(existingImagePaths));


//       const response = await axios.post(`${config.BASE_URL}/api/v1/sendEmail`, formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       if (response.status === 200) {
//         toast.success("Email sent successfully!");
//       } else {
//         toast.error("Failed to send email. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error sending email:", error);
//       toast.error("Error sending email. Please check the console for more details.");
//     } finally {
//       setIsEmailLoading(false); // End button loader
//     }
//   };

// useEffect(() => {
//   const total = products.reduce((acc, p) => {
//     const qty = parseFloat(p.quantity) || 0;
//     const price = parseFloat(p.price) || 0;
//     return acc + qty * price;
//   }, 0);

//   setTotalAmount(total-discount);
// }, [products]);

//   useEffect(() => {
//   const tp = parseFloat(totalAmount) || 0;
//   const paid = parseFloat(amountPaid) || 0;
//   setAmountDue(Math.max(0, tp - paid));
// }, [totalAmount, amountPaid]);


//   // let customerId=customer?._id;
//   //   console.log(uploadedImage)
//   const handleSave = async () => {
//     try {
//       // const invoiceData = {
//       //    invoiceId: id,
//       //   invoiceDate,
//       //   invoiceNo,
//       //   totalAmount,
//       //   amountPaid,
//       //   amountDue,
//       //   comments,
//       //   id,
//       //   uploadedImage,
//       //    deposit,
//       //  modeOfPayment,
//       // };

//       const formData = new FormData();

//       // Append all invoice fields


//       formData.append("invoiceId", id);
//       formData.append("invoiceDate", invoiceDate);
//       formData.append("invoiceNo", invoiceNo);
//       formData.append("totalAmount", totalAmount);
//       formData.append("amountPaid", amountPaid);
//       formData.append("amountDue", amountDue);
//       formData.append("comments", comments);
//       formData.append("deposit", JSON.stringify(deposits)); 


//       formData.append("modeOfPayment", modeOfPayment);
//       formData.append("products", JSON.stringify(products));


//     const existingImages = uploadedImages.filter(
//       (image) => typeof image === 'string'
//     );
//     const newImages = uploadedImages.filter(
//       (image) => image instanceof File
//     );

//     // 2. Append ONLY the new files to the 'images' field for multer to process.
//     newImages.forEach((file) => {
//       formData.append("images", file);
//     });


//     formData.append("existingImages", JSON.stringify(existingImages));
//       const response = await axios.post(`${config.BASE_URL}/api/v1/addInvoice`, formData);

//       if (response.status === 201) {
//         fetchInvoice(id);
//         toast.success("Invoice saved successfully!");

//       } else if (response.status === 200) {
//         const data = {
//           totalPrice:totalAmount,
//           discount:discount
//         }
//          const res = await axios.patch(`${config.BASE_URL}/api/v1/quote/update-discount/${response?.data?.invoice?.quote_id}`, data)

//         toast.success("Invoice update successfully!");
//       }

//       else {
//         toast.error("Failed to save the invoice.");
//       }
//     } catch (error) {
//       console.error("Error saving invoice:", error);
//       toast.error("An error occurred while saving the invoice.");
//     }
//   };

// const handleRemoveImage = (indexToRemove) => {
//   setUploadedImages((prevImages) =>
//     prevImages.filter((_, index) => index !== indexToRemove)
//   );
// };

//   return (

// <>
//      {isLoading ? (
//       <div className="loader-container">
//         <ClipLoader color="#123abc" size={80} />
//       </div>
//     ) : (


//     <Layout>


//       <header className="header">
//         <h1>Edit Invoice</h1>
//         <p><Link to="/" className="home-link">  <HomeIcon /> </Link> / Customers / Edit Invoice</p>
//       </header>

//       <div className="invoice_outer">

//         <div className="invoce_outer_btns">
//          <button
//   onClick={() => handleEmail(customer)}
//   type="button"
//   className="btn"
//   disabled={isEmailLoading}
// >
//   {isEmailLoading ? (
//     <>
//       <ClipLoader color="#fff" size={18} /> Sending...
//     </>
//   ) : (
//     "Email"
//   )}
// </button>

//           <button onClick={handleGeneratePDF} className="btn">PDF</button>
//           <button onClick={handleSave} className="btn">Save</button>
//           <button onClick={() => navigate(`/edit-quote/${quoteId}`)} className="btn">Back To Quote</button>
//         </div>

//         <div className="invoice_card" id="invoice">
//           <div className="invoice_card_header">
//             <div className="logo">
//               <img src={Logo} alt="" />
//             </div>
//             <p>CBD Showroom: Suite 513, Level 5, 250 Pitt Street, Sydney 2000</p>
//             <p>Western Sydney: 6, Ambleside Drive, Castle Hill, NSW 2154</p>
//             <p>Ph: 02 9863 6911, Mobile: 0414 984 976</p>
//             <p>ABN: 14146359560</p>
//           </div>
//           <h4 className="tax_invoice_title">Tax Invoice</h4>
//           <div className="invoice_custom_details">
//             <div className="customer_details">
//               <p className="customer_name">{customer?.customer_name}</p>
//               <p className="location">{customer?.address}</p>
//               <p className="email">{customer?.email}</p>
//               <p className="phone_number">{customer?.mobile}</p>
//             </div>
//             <div className="invoice_details_table">
//               <table class="meta">
//                 <tr>
//                   <th><span>Invoice #</span></th>
//                   <td><span>{invoiceNo}</span></td>
//                 </tr>
//                 <tr>
//                   <th><span>Date</span></th>
//                   <td><input type="date"
//                     value={invoiceDate}
//                     onChange={(e) => setInvoiceDate(e.target.value)}
//                   /></td>
//                 </tr>
//                   { discount > 0 && <tr>
//                     <th>
//                       <span>Discount</span>
//                     </th>
//                     <td>
//                       {discount}
//                     </td>
//                   </tr>}
//                 <tr>
//                   <th><span>Amount Due ($)</span></th>
//                   <td>
//                     <input
//                       type="number"
//                       id="amountDue"
//                       name="amountDue"
//                      value={Number(parseFloat(amountDue).toFixed(2))}
//                       readOnly
//                       className=""
//                     />
//                   </td>
//                 </tr>
//               </table>
//             </div>
//           </div>

//           <div className="invoice_specification_details">
//             <table className="details">
//               <thead>
//                 <tr>
//                   <th>Item</th>
//                   <th>Fabric / Lining</th>
//                   <th>Quantity</th>
//                   <th>Price ($)</th>
//                   <th>Amount ($)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {products.map((product, index) => (
//                   <tr key={index}>
//                     <td className="with_cut_td">
//                        {index === products.length - 1 ? (
//                         <a className="cut" onClick={handleAddItem}>
//                           +
//                         </a>
//                       ) : (
//                         <a
//                           className="cut"
//                           onClick={() => handleDeleteItem(index)}
//                         >
//                           x
//                         </a>
//                       )} 
//                        <select
//                         contentEditable
//                         id="description"
//                         value={product.description}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].style = e.target.value;
//                           setProducts(updatedProducts);
//                         }}
//                         formcontrolname="description"
//                         className="ng-pristine ng-valid ng-touched"
//                       >
//                         <option value=""> </option>
//                         <option value="Suit">Suit</option>
//                         <option value="Jacket">Jacket</option>
//                         <option value="Shirt">Shirt</option>
//                         <option value="Pant">Pant</option>
//                         <option value="Tuxedo">Tuxedo</option>
//                         <option value="Vest">Vest</option>
//                         <option value="Overcoat">Overcoat</option>
//                         <option value="Accessories">Accessories</option>
//                       </select> 
//                       {/* <input type="text" value={product.description} disabled /> */}
//                     </td>
//                     {/* <td>
//                       <input
//                         type="text"
//                         value={product.fabric}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].fabric = e.target.value;
//                           setProducts(updatedProducts);
//                         }}
//                         contenteditable
//                         formcontrolname="material"
//                       />
//                     </td> */}
//                      {/* <td>
//   <input
//     type="text"
//     placeholder="Fabric / Lining"
//     // Use a temporary display value for smooth typing, fallback to combined state
//     value={
//       product.displayFabricLining !== undefined 
//         ? product.displayFabricLining 
//         : `${product.fabric || ''} / ${product.lining || ''}`
//     }
//     onChange={(e) => {
//       const val = e.target.value;
//       const updatedProducts = [...products];

//       // 1. Store the raw typed string to prevent cursor jumps and spacing issues
//       updatedProducts[index].displayFabricLining = val;

//       // 2. Split the string by the first "/"
//       const splitIndex = val.indexOf('/');

//       if (splitIndex !== -1) {
//         // Anything before the "/" goes to fabric
//         updatedProducts[index].fabric = val.substring(0, splitIndex).trim();
//         // Anything after the "/" goes to lining
//         updatedProducts[index].lining = val.substring(splitIndex + 1).trim();
//       } else {
//         // If there's no "/", assign everything to fabric
//         updatedProducts[index].fabric = val.trim();
//         updatedProducts[index].lining = '';
//       }

//       setProducts(updatedProducts);
//     }}
//     onBlur={() => {
//       // Optional: Auto-format it cleanly to "Fabric / Lining" when the user clicks away
//       const updatedProducts = [...products];
//       const f = updatedProducts[index].fabric || '';
//       const l = updatedProducts[index].lining || '';

//       // Only add the slash if lining exists
//       updatedProducts[index].displayFabricLining = `${f} / ${l}`;
//       setProducts(updatedProducts);
//     }}
//   />
// </td> */}

// <td>
//   <input
//     type="text"
//     placeholder="Fabric / Lining"
//     value={
//       product.displayFabricLining !== undefined 
//         ? product.displayFabricLining 
//         : `${product.fabric || ''} / ${product.lining || ''}`
//     }
//     // 🔥 DYNAMIC ALIGNMENT: Centers the text ONLY if it is exactly " / "
//     style={{ 
//       textAlign: (
//         product.displayFabricLining === ' / ' || 
//         (!product.fabric && !product.lining && product.displayFabricLining === undefined)
//       ) ? 'center' : 'left',
//       width: '100%' // Ensures the input takes up the full cell so center alignment works
//     }}
//     onChange={(e) => {
//       const val = e.target.value;
//       const updatedProducts = [...products];

//       updatedProducts[index].displayFabricLining = val;

//       const splitIndex = val.indexOf('/');

//       if (splitIndex !== -1) {
//         updatedProducts[index].fabric = val.substring(0, splitIndex).trim();
//         updatedProducts[index].lining = val.substring(splitIndex + 1).trim();
//       } else {
//         updatedProducts[index].fabric = val.trim();
//         updatedProducts[index].lining = '';
//       }

//       setProducts(updatedProducts);
//     }}
//     onBlur={() => {
//       const updatedProducts = [...products];
//       const f = updatedProducts[index].fabric || '';
//       const l = updatedProducts[index].lining || '';

//       updatedProducts[index].displayFabricLining = `${f} / ${l}`;
//       setProducts(updatedProducts);
//     }}
//   />
// </td>

//                     <td>
//                       <input
//                         type="number"
//                         value={product.quantity}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].quantity = parseInt(e.target.value) || 0;
//                           setProducts(updatedProducts);
//                         }}

//                         contenteditable
//                         formcontrolname="qty"
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="number"
//                         min="0"
//                         value={product.price}
//                         onChange={(e) => {
//                           const updatedProducts = [...products];
//                           updatedProducts[index].price = parseFloat(e.target.value ) ;
//                           setProducts(updatedProducts);
//                         }}
//                         contenteditable
//                         formcontrolname="price"
//                       />
//                     </td>
//                     <td>
//                       <input
//                         type="text"
//                        value={(Number(product.quantity) || 0) * (Number(product.price) || 0)}
//                         readOnly
//                         formcontrolname="total"
//                       />
//                     </td>

//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>




//           <div className="invoice_balance">

//             <table class="balance">
//               <tr>
//                 <th><span>Total Amount ($)</span></th>
//                 <td><input type="number" value={totalAmount} readOnly contenteditable=""  formcontrolname="totalAmount" class="ng-untouched ng-pristine ng-valid" /></td>
//               </tr>
//               <tr>
//                 <th><span>Amount Paid ($)</span></th>
//                 <td>
//                   <input
//                     type="number"
//                     value={Number(parseFloat(amountPaid).toFixed(2))} 
//                     readOnly 
//                     // onChange={(e) => setAmountPaid(e.target.value)}  // Update state on change
//                     className="form-control"
//                   />
//                 </td>
//               </tr>
//              <tr>

//   <th className="no-pdf" colSpan="2">
//    <div style={{ marginTop: "10px" }}>
//   <label><b>Deposit Details</b> <span style={{ fontWeight: "normal" }}>(enter % or amount and select mode):</span></label>

//   <div className="invoice-deposit-new" >
//     <span>Deposit</span>
//     <span>%</span>
//     <span></span>
//     <span>Amount $</span>
//     <span>Mode</span>
//   </div>

//   {[0, 1, 2].map((index) => (
//     <div
//       key={index}
//       className="invoice-deposit-new"
//       // style={{
//       //   display: "grid",
//       //   gridTemplateColumns: "80px 70px 20px 100px 120px",
//       //   alignItems: "center",
//       //   gap: "10px",
//       //   padding: "8px 0",
//       //   borderBottom: "1px solid #eee",
//       //   backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
//       // }}
//     >
//       <strong style={{ fontWeight: 500 }}>Deposit {index + 1}</strong>

//       <input
//         type="number"
//         placeholder="%"
//         min="0"
//         max="100"
//         value={deposits[index]?.percent || ""}
//         onChange={(e) => handleDepositChange(index, "percent", e.target.value)}
//         style={{ width: "100%", padding: "6px" }}
//       />
//       <span>%</span>

//       <input
//   type="number"
//   placeholder="Amount"
//   min="0"
//   step="0.01" // Allows decimals in the UI
//   // Use the raw value so the user can type decimals properly
//   value={deposits[index]?.amount} 
//   onChange={(e) => handleDepositChange(index, "amount", e.target.value)}
//   style={{ width: "100%", padding: "6px" }}
// />

//       <select
//         value={deposits[index]?.mode || ""}
//         onChange={(e) => handleDepositChange(index, "mode", e.target.value)}
//         style={{ width: "100%", padding: "6px" }}
//       >
//         <option value="">Mode</option>
//         <option value="CC">CC</option>
//         <option value="EFT">EFT</option>
//         <option value="Cash">Cash</option>
//       </select>
//     </div>
//   ))}
// </div>

//   </th>


// </tr>


//             </table>
//           </div>


//       <div className="invoice_comment">
//               <div className="form-group">
//                 <label htmlFor="comments">Comments</label>
//                 <textarea
//                   id="comments"
//                   value={comments}
//                   onChange={(e) => setComments(e.target.value)}  // Add this to update the state
//                   className="form-control"
//                 />
//               </div>
//             </div>
//           <div className="invoice_thanks_message">
//             <h5>Thank you for your business</h5>
//           </div>

//           <div className="no-pdf" style={{ marginBottom: "20px" }}>
//             <label><b>Upload Images:</b></label><br />
//              <input
//               type="file"
//               accept="image/*"
//               multiple
//               onChange={(e) => {
//                 const newFiles = Array.from(e.target.files);

//                 setUploadedImages((prevImages) => [...prevImages, ...newFiles]);
//               }}
//             />
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
//               {uploadedImages.map((img, i) => {
//                 const isFile = img instanceof File;
//                 // Create a URL for previewing the file
//                 const imageUrl = isFile ? URL.createObjectURL(img) : `${config.BASE_URL}${img}`;

//                 return (
//                   <div key={i} style={{ position: 'relative' }}>
//                     <img
//                       src={imageUrl}
//                       alt={`preview-${i}`}
//                       style={{ width: "80px", height: "80px", objectFit: 'cover', border: "1px solid #ccc" }}
//                     />
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveImage(i)}
//                       style={{
//                         position: 'absolute',
//                         top: '2px',
//                         right: '2px',
//                         background: 'rgba(0, 0, 0, 0.5)',
//                         color: 'white',
//                         border: 'none',
//                         borderRadius: '50%',
//                         width: '20px',
//                         height: '20px',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         fontSize: '14px',
//                         lineHeight: '1'
//                       }}
//                     >
//                       &times;
//                     </button>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>



//           <div className="invoice_bottom_text" style={{ 
//     pageBreakInside: "avoid",
//     breakInside: "avoid"
//   }}>
//             <p><b>Bank Details:</b></p>
//             <p>Bank: Commonwealth Bank Of Australia</p>
//             <p>Account Name: Bentex Suits</p>
//             <p>BSB: 062 443, Account Number: 1084 1834</p>
//             <p>Please Mention Your Invoice Number When Making EFT Payment</p>
//           </div>
//         </div>
//       </div>
//     </Layout>
// )}

// </>
//   );
// };

// export default Invoice;


// import React from 'react';


import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Layout from "../pages/Layout";
import HomeIcon from "../assets/icons/home_icon";
import Logo from "../images/bentex-logo.png";
import axios from "axios";
import config from "../config";
import { jsPDF } from "jspdf";
import { useRef } from 'react';
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";

const Invoice = ({ customerDetails, invoiceDetails, items, handlePDF }) => {
  const { id } = useParams();
  const location = useLocation();
  const [amountPaid, setAmountPaid] = useState(0);
  const navigate = useNavigate()
  const [deposits, setDeposits] = useState([
    { percent: 0, amount: 0, mode: "" },
    { percent: 0, amount: 0, mode: "" },
    { percent: 0, amount: 0, mode: "" },
  ]);

  const queryParams = new URLSearchParams(location.search);

  const [uploadedImages, setUploadedImages] = useState([]);
  const [isEmailLoading, setIsEmailLoading] = useState(false);

  const [quoteNo, setQuoteNo] = useState("");
  const [base64Images, setBase64Images] = useState([]);
  const [discount, setDiscount] = useState(0)
  const [isLoading, setIsLoading] = useState(true);

  const [comments, setComments] = useState("");
  const [customer, setCustomer] = useState("");
  const [products, setProducts] = useState([]);
  const [amountDue, setAmountDue] = useState();
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split('T')[0]);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [quoteId, setQuoteId] = useState(null)
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [isEditingDiscount, setIsEditingDiscount] = useState(false);

  useEffect(() => {
    setAmountDue(totalAmount - amountPaid);
  }, [totalAmount, amountPaid]);

  useEffect(() => {
    const convertImagesToBase64 = async () => {
      const promises = uploadedImages.map(async (img) => {
        if (img instanceof File) {
          return await toBase64(img);
        } else {
          return `${config.BASE_URL}${img}`;
        }
      });
      const results = await Promise.all(promises);
      setBase64Images(results);
    };
    convertImagesToBase64();
  }, [uploadedImages]);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  useEffect(() => {
    const tp = parseFloat(totalAmount) || 0;
    if (tp === 0) return;

    const updated = deposits.map((d) => {
      const amount = parseFloat(d.amount) || 0;
      const percent = (amount / tp) * 100;
      return {
        ...d,
        amount: amount,
        percent: percent,
      };
    });

    setDeposits(updated);
    const totalPaid = updated.reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
    setAmountPaid(totalPaid);
    setAmountDue(tp - totalPaid);
  }, [totalAmount]);


  const fetchInvoice = async (invoiceId) => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${config.BASE_URL}/api/convert/invoice/${invoiceId}`);
      const invData = response.data.invoice;
      

      setInvoiceNo(invData?.invoice_no);
      setTotalAmount(invData?.amount);
      setModeOfPayment(invData?.modeOfPayment);
      setAmountPaid(invData?.amount_paid);
      setComments(invData?.comments || "");
      setCustomer(invData?.customer_id);
      setUploadedImages(invData?.images || []);

      const depositData = invData?.deposit;
      setQuoteId(invData?.quote_id?._id);
      setDiscount(Number(invData?.discount) || 0);
       if (invData?.invoice_date) {
      setInvoiceDate(new Date(invData.invoice_date).toISOString().split("T")[0]);
    }

    
      const productData = response.data.productDetail || [];
      setProducts(productData);

      // Deposit Mapping
      if (Array.isArray(depositData)) {
        const normalizedDeposits = [
          { percent: 0, amount: 0, mode: "" },
          { percent: 0, amount: 0, mode: "" },
          { percent: 0, amount: 0, mode: "" },
        ];
        depositData.forEach((d, i) => {
          if (i < 3) {
            normalizedDeposits[i] = {
              percent: Number(d.percent) || 0,
              amount: Number(d.amount) || 0,
              mode: d.mode || "",
            };
          }
        });
        setDeposits(normalizedDeposits);
      }
    } catch (error) {
      console.error("Failed to fetch invoice:", error);
      toast.error("Failed to load invoice data.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDepositChange = (index, field, value) => {
    const totalInvoiceAmount = parseFloat(totalAmount) || 0;
    const updated = [...deposits];
    let numericValue = parseFloat(value) || 0;

    if (field === "amount") {
      if (value === "") {
        updated[index].amount = "";
        updated[index].percent = 0;
      } else {
        let numericValue = parseFloat(value) || 0;
        const otherDepositsTotal = updated.reduce((acc, d, i) => {
          if (i !== index) return acc + (parseFloat(d.amount) || 0);
          return acc;
        }, 0);

        const maxAllowed = Math.max(0, totalInvoiceAmount - otherDepositsTotal);
        if (numericValue > maxAllowed) {
          numericValue = maxAllowed;
          toast.warn(`Cannot exceed total remaining amount due ($${maxAllowed.toFixed(2)}).`);
        }
        updated[index].amount = numericValue;
        const percent = totalInvoiceAmount > 0 ? (numericValue / totalInvoiceAmount) * 100 : 0;
        updated[index].percent = percent.toFixed(2);
      }
    } else if (field === "percent") {
      if (numericValue < 0) numericValue = 0;
      if (numericValue > 100) numericValue = 100;

      let calculatedAmount = (numericValue / 100) * totalInvoiceAmount;
      calculatedAmount = parseFloat(calculatedAmount.toFixed(2));

      if (calculatedAmount > totalInvoiceAmount) {
        numericValue = 100;
        updated[index].amount = totalInvoiceAmount;
      } else {
        updated[index].amount = calculatedAmount;
      }
      updated[index].percent = numericValue;
    } else if (field === "mode") {
      updated[index].mode = value;
    }

    setDeposits(updated);
    const totalPaid = updated.reduce((acc, d) => acc + (parseFloat(d.amount) || 0), 0);
    setAmountPaid(totalPaid);
    setAmountDue(totalInvoiceAmount - totalPaid);
  };

  useEffect(() => {
    fetchInvoice(id);
  }, []);

  const handleGeneratePDF = async () => {
    if (uploadedImages.length > 0 && base64Images.length !== uploadedImages.length) {
      toast.error("Images are still loading, please try again in a moment.");
      return;
    }

    const element = document.getElementById("invoice");
    element.classList.add("pdf-mode");
    await waitForImagesToLoad(element);

    const customerName = customer?.customer_name ? customer.customer_name.replace(/\s+/g, "_") : "Customer";
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}`;
    const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;

    const options = {
      margin: 0.2,
      filename: fileName,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2, useCORS: true, async: true, logging: true, ignoreElements: (el) => el.classList.contains("no-pdf"),
      },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'], avoid: '.invoice_bottom_text' }
    };

    try {
      await html2pdf().set(options).from(element).save();
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF.");
    }
  };

  const waitForImagesToLoad = (element) => {
    const images = element.querySelectorAll('img');
    return Promise.all(
      Array.from(images).map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise((resolve) => { img.onload = img.onerror = resolve; });
      })
    );
  };

  // ✅ INLINE ADD PRODUCT (Jab user "+" icon dabata hai khali row ke liye)
  const handleAddItem = () => {
    const newItem = {
      description: '',
      fabric: '',
      lining: '',
      quantity: 1,
      price: 0,
      image: null,
    };
    setProducts([...products, newItem]);
  };

  // ✅ SAFE DELETE ITEM (Kabhi Quote delete nahi hoga)
  const handleDeleteItem = async (index) => {
    const productToDelete = products[index];
    const confirmDelete = window.confirm("Are you sure you want to remove this product from the invoice?");
    if (!confirmDelete) return;

    // Agar ye product strictly Invoice ka hai DB se udega.
    if (productToDelete._id && productToDelete.invoice_id && !productToDelete.quote_id) {
      try {
        await axios.delete(`${config.BASE_URL}/api/v1/deleteProduct/${productToDelete._id}`);
        toast.success("Product deleted from invoice.");
      } catch (error) {
        console.error("Error deleting product:", error);
        toast.error("Failed to delete product from database.");
        return;
      }
    }

    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
  };

  const handleEmail = async () => {
    setIsEmailLoading(true);
    const customerName = customer?.customer_name ? customer.customer_name.replace(/\s+/g, "_") : "Customer";
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(today.getMonth() + 1).padStart(2, "0")}-${today.getFullYear()}`;
    const fileName = `Invoice_${customerName}_${formattedDate}.pdf`;

    try {
      const element = document.getElementById("invoice");
      element.classList.add("pdf-mode");
      const options = {
        margin: 0.2, filename: fileName, image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, ignoreElements: (el) => el.classList.contains("no-pdf") },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ['css', 'legacy'], avoid: '.invoice_bottom_text' }
      };

      const pdfBlob = await html2pdf().from(element).set(options).outputPdf("blob");
      const formData = new FormData();
      formData.append("name", customer.customer_name);
      formData.append("email", customer.email);
      formData.append("subject", invoiceNo);
      formData.append("title", fileName);
      formData.append("pdf", pdfBlob, "invoice.pdf");
      formData.append("type", "invoice")

      const existingImagePaths = uploadedImages.filter((image) => typeof image === 'string');
      const newImageFiles = uploadedImages.filter((image) => image instanceof File);

      newImageFiles.forEach((file) => formData.append("invoiceImages", file));
      formData.append("existingImages", JSON.stringify(existingImagePaths));

      const response = await axios.post(`${config.BASE_URL}/api/v1/sendEmail`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) { toast.success("Email sent successfully!"); }
      else { toast.error("Failed to send email. Please try again."); }
    } catch (error) { toast.error("Error sending email."); }
    finally { setIsEmailLoading(false); }
  };

  useEffect(() => {
    const total = products.reduce((acc, p) => {
      const qty = parseFloat(p.quantity) || 0;
      const price = parseFloat(p.price) || 0;
      return acc + qty * price;
    }, 0);
    setTotalAmount(total - discount);
  }, [products, discount]);

  useEffect(() => {
    const tp = parseFloat(totalAmount) || 0;
    const paid = parseFloat(amountPaid) || 0;
    setAmountDue(Math.max(0, tp - paid));
  }, [totalAmount, amountPaid]);


  // 🔥 MAIN LOGIC UPDATE: Cleaned up double API calls 🔥
  const handleSave = async () => {
    try {
      setIsLoading(true);

      // 1. Completely empty rows filter out kar diye hain taaki error na aaye
      const validProducts = products.filter(p => p.description || p.fabric || p.quantity || p.price);

      // 2. INVOICE SAVE KARNE KA LOGIC (Backend will handle products directly)
      const formData = new FormData();
      formData.append("invoiceId", id);
      formData.append("invoiceDate", invoiceDate);
      formData.append("invoiceNo", invoiceNo);
      formData.append("discount", discount);
      formData.append("totalAmount", totalAmount);
      formData.append("amountPaid", amountPaid);
      formData.append("amountDue", amountDue);
      formData.append("comments", comments);
      formData.append("deposit", JSON.stringify(deposits));
      formData.append("modeOfPayment", modeOfPayment);

      // Seedha validProducts bhej do, Backend khud inko create ya update kar lega!
      formData.append("products", JSON.stringify(validProducts));

      const existingImages = uploadedImages.filter((image) => typeof image === 'string');
      const newImages = uploadedImages.filter((image) => image instanceof File);

      newImages.forEach((file) => formData.append("images", file));
      formData.append("existingImages", JSON.stringify(existingImages));

      // Ek hi API call sab kuch handle kar legi
      const response = await axios.post(`${config.BASE_URL}/api/v1/addInvoice`, formData);

      if (response.status === 201 || response.status === 200) {

        toast.success("Invoice saved successfully!");

        // Data dubara DB se uthaenge taaki naye added products ko unki _id mil jaye
        fetchInvoice(id);
      } else {
        toast.error("Failed to save the invoice.");
      }
    } catch (error) {
      console.error("Error saving invoice:", error);
      toast.error("An error occurred while saving the invoice.");
    } finally {
      setIsLoading(false);
    }
  };
  const handleRemoveImage = (indexToRemove) => {
    setUploadedImages((prevImages) => prevImages.filter((_, index) => index !== indexToRemove));
  };

  const discountValue = discount === "" ? 0 : discount;

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <ClipLoader color="#123abc" size={80} />
        </div>
      ) : (
        <Layout>
          <header className="header">
            <h1>Edit Invoice</h1>
            <p><Link to="/" className="home-link"><HomeIcon /> </Link> / Customers / Edit Invoice</p>
          </header>

          <div className="invoice_outer">
            <div className="invoce_outer_btns">
              <button onClick={() => handleEmail(customer)} type="button" className="btn" disabled={isEmailLoading}>
                {isEmailLoading ? <><ClipLoader color="#fff" size={18} /> Sending...</> : "Email"}
              </button>
              <button onClick={handleGeneratePDF} className="btn">PDF</button>
              <button onClick={handleSave} className="btn">Save</button>
              {/* <button onClick={() => navigate(`/edit-quote/${quoteId}`)} className="btn">Back To Quote</button> */}
            </div>

            <div className="invoice_card" id="invoice">
              <div className="invoice_card_header">
                <div className="logo"><img src={Logo} alt="" /></div>
                <p>CBD Showroom: Suite 513, Level 5, 250 Pitt Street, Sydney 2000</p>
                <p>Western Sydney: 6, Ambleside Drive, Castle Hill, NSW 2154</p>
                <p>Ph: 02 9863 6911, Mobile: 0414 984 976</p>
                <p>ABN: 14146359560</p>
              </div>
              <h4 className="tax_invoice_title">Tax Invoice</h4>
              <div className="invoice_custom_details">
                <div className="customer_details">
                  <p className="customer_name">{customer?.customer_name}</p>
                  <p className="location">{customer?.address}</p>
                  <p className="email">{customer?.email}</p>
                  <p className="phone_number">{customer?.mobile}</p>
                </div>
                <div className="invoice_details_table">
                  <table className="meta">
                    <tbody>
                      <tr>
                        <th><span>Invoice #</span></th>
                        <td><span>{invoiceNo}</span></td>
                      </tr>
                      <tr>
                        <th><span>Date</span></th>
                        <td>
                          <input type="date" value={invoiceDate} onChange={(e) => setInvoiceDate(e.target.value)} />
                        </td>
                      </tr>
                      {/* {(discount > 0 || isEditingDiscount) && (
                        <tr>
                          <th><span>Discount ($)</span></th>
                          <td>
                            <input
                              type="number"
                              min="0"
                              value={discount === 0 ? "" : discount}
                              onFocus={() => setIsEditingDiscount(true)}
                              onBlur={() => {
                                setIsEditingDiscount(false);

                               
                                if (!discount || discount <= 0) {
                                  setDiscount(0);
                                }
                              }}
                              onChange={(e) => {
                                const val = e.target.value;

                                if (val === "") {
                                  setDiscount("");
                                } else {
                                  setDiscount(parseFloat(val));
                                }
                              }}
                            />
                          </td>
                        </tr>
                      )} */}

                      <tr className={discountValue <= 0 ? "hide-in-pdf" : ""}>
                        <th>Discount ($)</th>
                        <td>
                          <input
                            type="number"
                            value={discount}
                            onChange={(e) => {
                              const value = e.target.value;

                              if (value === "") {
                                setDiscount(""); // allow empty
                              } else {
                                setDiscount(parseFloat(value));
                              }
                            }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th><span>Amount Due ($)</span></th>
                        <td>
                          <input type="number" value={Number(parseFloat(amountDue).toFixed(2))} readOnly />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* ✅ INLINE EDITABLE PRODUCTS TABLE */}
              <div className="invoice_specification_details">
                <table className="details">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Fabric / Lining</th>
                      <th>Quantity</th>
                      <th>Price ($)</th>
                      <th>Amount ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.length === 0 && (
                      <tr>
                        <td colSpan="5" style={{ textAlign: "center" }}>
                          <button type="button" className="btn" onClick={handleAddItem} style={{ margin: "10px" }}>+ Add Product</button>
                        </td>
                      </tr>
                    )}
                    {products.map((product, index) => (
                      <tr key={index}>
                        <td className="with_cut_td">
                          {/* ✅ PLUS OR CROSS ICON */}
                          {index === products.length - 1 ? (
                           <a className="cut" onClick={() => handleDeleteItem(index)} style={{ cursor: "pointer" }}>x</a>
                          ) : (
                            <a className="cut" onClick={() => handleDeleteItem(index)} style={{ cursor: "pointer" }}>x</a>
                          )}
                          <select
                            contentEditable
                            id="description"
                            value={product.description || product.style} // handle both keys just in case
                            onChange={(e) => {
                              const updatedProducts = [...products];
                              updatedProducts[index].description = e.target.value;
                              updatedProducts[index].style = e.target.value;
                              setProducts(updatedProducts);
                            }}
                            className="ng-pristine ng-valid ng-touched"
                          >
                            <option value=""> </option>
                            <option value="Suit">Suit</option>
                            <option value="Jacket">Jacket</option>
                            <option value="Shirt">Shirt</option>
                            <option value="Pant">Pant</option>
                            <option value="Tuxedo">Tuxedo</option>
                            <option value="Vest">Vest</option>
                            <option value="Overcoat">Overcoat</option>
                            <option value="Accessories">Accessories</option>
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            placeholder="Fabric / Lining"
                            value={product.displayFabricLining !== undefined ? product.displayFabricLining : `${product.fabric || ''} / ${product.lining || ''}`}
                            style={{
                              textAlign: (product.displayFabricLining === ' / ' || (!product.fabric && !product.lining && product.displayFabricLining === undefined)) ? 'center' : 'left',
                              width: '100%'
                            }}
                            onChange={(e) => {
                              const val = e.target.value;
                              const updatedProducts = [...products];
                              updatedProducts[index].displayFabricLining = val;
                              const splitIndex = val.indexOf('/');
                              if (splitIndex !== -1) {
                                updatedProducts[index].fabric = val.substring(0, splitIndex).trim();
                                updatedProducts[index].lining = val.substring(splitIndex + 1).trim();
                              } else {
                                updatedProducts[index].fabric = val.trim();
                                updatedProducts[index].lining = '';
                              }
                              setProducts(updatedProducts);
                            }}
                            onBlur={() => {
                              const updatedProducts = [...products];
                              const f = updatedProducts[index].fabric || '';
                              const l = updatedProducts[index].lining || '';
                              updatedProducts[index].displayFabricLining = `${f} / ${l}`;
                              setProducts(updatedProducts);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={product.quantity || ''}
                            onChange={(e) => {
                              const updatedProducts = [...products];
                              updatedProducts[index].quantity = parseInt(e.target.value) || 0;
                              setProducts(updatedProducts);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            min="0"
                            value={product.price || ''}
                            onChange={(e) => {
                              const updatedProducts = [...products];
                              updatedProducts[index].price = parseFloat(e.target.value) || 0;
                              setProducts(updatedProducts);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            value={(Number(product.quantity) || 0) * (Number(product.price) || 0)}
                            readOnly
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div>
                   <div onClick={handleAddItem} className="plus-icon-invoice">  <a className=""  style={{ cursor: "pointer" }}>+</a></div>
                </div>
                
              </div>
                
              <div className="invoice_balance">
                <table className="balance">
                  <tbody>
                    <tr>
                      <th><span>Total Amount ($)</span></th>
                      <td><input type="number" value={totalAmount} readOnly /></td>
                    </tr>
                    <tr>
                      <th><span>Amount Paid ($)</span></th>
                      <td>
                        <input type="number" value={Number(parseFloat(amountPaid).toFixed(2))} readOnly className="form-control" />
                      </td>
                    </tr>
                    <tr>
                      <th className="no-pdf" colSpan="2">
                        <div style={{ marginTop: "10px" }}>
                          <label><b>Deposit Details</b> <span style={{ fontWeight: "normal" }}>(enter % or amount and select mode):</span></label>
                          <div className="invoice-deposit-new">
                            <span>Deposit</span>
                            <span>%</span>
                            <span></span>
                            <span>Amount $</span>
                            <span>Mode</span>
                          </div>
                          {[0, 1, 2].map((index) => (
                            <div key={index} className="invoice-deposit-new">
                              <strong style={{ fontWeight: 500 }}>Deposit {index + 1}</strong>
                              <input
                                type="number" placeholder="%" min="0" max="100"
                                value={deposits[index]?.percent || ""}
                                onChange={(e) => handleDepositChange(index, "percent", e.target.value)}
                                style={{ width: "100%", padding: "6px" }}
                              />
                              <span>%</span>
                              <input
                                type="number" placeholder="Amount" min="0" step="0.01"
                                value={deposits[index]?.amount}
                                onChange={(e) => handleDepositChange(index, "amount", e.target.value)}
                                style={{ width: "100%", padding: "6px" }}
                              />
                              <select
                                value={deposits[index]?.mode || ""}
                                onChange={(e) => handleDepositChange(index, "mode", e.target.value)}
                                style={{ width: "100%", padding: "6px" }}
                              >
                                <option value="">Mode</option>
                                <option value="CC">CC</option>
                                <option value="EFT">EFT</option>
                                <option value="Cash">Cash</option>
                              </select>
                            </div>
                          ))}
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
               
              </div>

              <div className="invoice_comment">
                <div className="form-group">
                  <label htmlFor="comments">Comments</label>
                  <textarea
                    id="comments" value={comments} onChange={(e) => setComments(e.target.value)}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="invoice_thanks_message">
                <h5>Thank you for your business</h5>
              </div>

              <div className="no-pdf" style={{ marginBottom: "20px" }}>
                <label><b>Upload Images:</b></label><br />
                <input
                  type="file" accept="image/*" multiple
                  onChange={(e) => {
                    const newFiles = Array.from(e.target.files);
                    setUploadedImages((prevImages) => [...prevImages, ...newFiles]);
                  }}
                />
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
                  {uploadedImages.map((img, i) => {
                    const isFile = img instanceof File;
                    const imageUrl = isFile ? URL.createObjectURL(img) : `${config.BASE_URL}${img}`;
                    return (
                      <div key={i} style={{ position: 'relative' }}>
                        <img src={imageUrl} alt={`preview-${i}`} style={{ width: "80px", height: "80px", objectFit: 'cover', border: "1px solid #ccc" }} />
                        <button
                          type="button" onClick={() => handleRemoveImage(i)}
                          style={{
                            position: 'absolute', top: '2px', right: '2px', background: 'rgba(0, 0, 0, 0.5)',
                            color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px',
                            cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '14px', lineHeight: '1'
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="invoice_bottom_text" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                <p><b>Bank Details:</b></p>
                <p>Bank: Commonwealth Bank Of Australia</p>
                <p>Account Name: Bentex Suits</p>
                <p>BSB: 062 443, Account Number: 1084 1834</p>
                <p>Please Mention Your Invoice Number When Making EFT Payment</p>
              </div>
            </div>
          </div>
        </Layout>
      )}
    </>
  );
};

export default Invoice;